export const IconHome = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
    <path
      fill="#F1A208"
      fillRule="evenodd"
      d="M9.75 15.75v-.015c0-.762.562-1.392 1.294-1.499a1.5 1.5 0 0 1 .206-2.986h.015c-.832 0-1.507-.67-1.515-1.5h6c-.008.83-.683 1.5-1.515 1.5h.015a1.5 1.5 0 0 1 .206 2.986 1.515 1.515 0 0 1 1.294 1.499v.015h-6Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF5722"
      fillRule="evenodd"
      d="M8.25 11.25v-1.5h-3v1.5a1.5 1.5 0 0 0-1.5-1.5h-1.5v3h1.5a1.5 1.5 0 0 0-1.5 1.5v1.5h3v-1.5a1.5 1.5 0 0 0 1.5 1.5h1.5v-3h-1.5a1.5 1.5 0 0 0 1.5-1.5Z"
      clipRule="evenodd"
    />
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={8}
        height={9}
        x={9}
        y={1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance'
        }}
      >
        <path
          fill="#fff"
          d="M12.82 1.43 9 5.25l3.818 3.818 3.818-3.818-3.818-3.818Z"
        />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#0038FF"
          fillRule="evenodd"
          d="M11.27 6.815a.594.594 0 0 0 .074.75l1.069 1.069a.594.594 0 0 0 .84 0l1.069-1.07a.594.594 0 0 0 .063-.765c.23.154.546.13.75-.074l1.069-1.07a.594.594 0 0 0 0-.84l-1.07-1.069a.594.594 0 0 0-.765-.063.594.594 0 0 0-.074-.75l-1.07-1.069a.594.594 0 0 0-.84 0l-1.069 1.07a.594.594 0 0 0-.063.765.594.594 0 0 0-.75.075L9.436 4.843a.594.594 0 0 0 0 .84l1.069 1.069c.208.208.534.23.766.063Z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <g clipPath="url(#c)">
      <mask
        id="d"
        width={7}
        height={7}
        x={2}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance'
        }}
      >
        <path fill="#fff" d="M2.25 2.25h6v6h-6v-6Z" />
      </mask>
      <g mask="url(#d)">
        <path
          fill="#00C0C4"
          d="M6.103 2.74a.992.992 0 0 0-1.711 0l-.014.024a.992.992 0 0 1-.849.49h-.027a.992.992 0 0 0-.856 1.482l.014.024a.992.992 0 0 1 0 .98l-.014.024a.992.992 0 0 0 .856 1.482h.027c.35.003.672.189.85.49l.013.024a.992.992 0 0 0 1.711 0l.014-.024a.992.992 0 0 1 .849-.49h.028a.992.992 0 0 0 .855-1.482l-.013-.024a.992.992 0 0 1 0-.98l.013-.024a.992.992 0 0 0-.855-1.482h-.028a.992.992 0 0 1-.849-.49l-.014-.024Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          d="m9.001 5.249 3.818-3.818 3.819 3.818-3.819 3.818z"
        />
      </clipPath>
      <clipPath id="c">
        <path fill="#fff" d="M8.25 2.25h-6v6h6z" />
      </clipPath>
    </defs>
  </svg>
)
